import React, { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';

export interface Block {
  id: number;
  page: string;
  sortOrder: number;
  type: 'text' | 'html';
  content: string;
}

// Renders the admin-managed content blocks for one page, in order. Text blocks
// become paragraphs; HTML blocks are sanitized with DOMPurify before being
// rendered, so an editor account can never inject scripts at visitors.
export function BlockView({ block }: { block: Block }): JSX.Element {
  if (block.type === 'html') {
    return (
      // eslint-disable-next-line react/no-danger
      <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(block.content) }} />
    );
  }
  return <p style={{ whiteSpace: 'pre-wrap' }}>{block.content}</p>;
}

function PageBlocks({ page }: { page: string }): JSX.Element {
  const [blocks, setBlocks] = useState<Block[]>([]);

  useEffect(() => {
    let cancelled = false;
    fetch(`/api/blocks/?page=${encodeURIComponent(page)}`)
      .then((res) => (res.ok ? res.json() : Promise.reject(new Error(`HTTP ${res.status}`))))
      .then((data: Block[]) => {
        if (!cancelled) setBlocks(data);
      })
      .catch(() => {
        // API down: the section simply renders nothing.
      });
    return () => {
      cancelled = true;
    };
  }, [page]);

  return (
    <>
      {blocks.map((block) => (
        <BlockView key={block.id} block={block} />
      ))}
    </>
  );
}

export default PageBlocks;
